import React from 'react';
import { useDispatch } from 'react-redux';

import { showFieldLogsDialog, type FieldLogsDialogProps } from '../dialogs/FieldLogsDialog';
import { executeStored } from '../Utils';

export interface LogsType {
	showLogs: boolean;
	switchShowLogs: () => void;
	hasLogs: (fieldName: string) => boolean;
	logsCounters: any;
	getLogsCounter: (fieldName: string) => number | undefined;
	openLogsDialog: (
		fieldName: FieldLogsDialogProps['fieldName'],
		fieldLabel: FieldLogsDialogProps['fieldLabel'],
		fieldParser?: FieldLogsDialogProps['fieldParser']
	) => void;
}

export default function useLogs({
	module,
	uid,
	updateRefresh
}: {
	module: string;
	uid?: string;
	updateRefresh: () => void;
}) {
	const dispatch = useDispatch();

	const [showLogs, setShowLogs] = React.useState(false);
	const switchShowLogs = () => setShowLogs(state => !state);

	const [logsCounters, setLogsCounters] = React.useState({});
	const hasLogs: LogsType['hasLogs'] = fieldName => showLogs && !!logsCounters[fieldName];
	const getLogsCounter: LogsType['getLogsCounter'] = fieldName => (showLogs ? logsCounters[fieldName] : undefined);

	const openLogsDialog: LogsType['openLogsDialog'] = (fieldName, fieldLabel, fieldParser) => {
		if (showLogs && hasLogs(fieldName))
			dispatch(
				showFieldLogsDialog({
					module,
					uid,
					fieldName,
					fieldLabel,
					fieldParser,
					updateRefresh
				})
			);
	};

	React.useEffect(() => {
		if (showLogs)
			executeStored({
				action: 'st_sys_logs_updates_counters',
				dispatch,
				params: { logs_table_uid: uid },
				successHandler: response => setLogsCounters(response.data)
			});
	}, [dispatch, setShowLogs, showLogs, uid]);

	return {
		showLogs,
		switchShowLogs,
		hasLogs,
		logsCounters,
		getLogsCounter,
		openLogsDialog
	} as LogsType;
}
